/** Phase 19 */
import { listAggregateNotifications } from '../infrastructure/storage/domainAggregateStore';
import { listEntityNotifications } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'notifications',
  listAggregate: listAggregateNotifications,
  listEntity: listEntityNotifications,
  idKeys: ['id', 'notificationId']
});

export const readNotificationsFromMergedBlob = source.readFromMergedBlob;
export const readNotificationsFromBestSource = source.readFromBestSource;
export const refreshNotificationsReadCache = source.refreshReadCache;
export const getCachedNotificationsRead = source.getCachedRead;
export const clearNotificationsReadCache = source.clearReadCache;
export const readNotificationsSyncForBusiness = source.readSyncForBusiness;
